import { convertToBoolean, getCookie, getLocaleCodeFromUrl } from 'src/utils'
import { APPConfig, IS_BROWSER } from 'config/appConfig'
import { trackInsiderUserObject } from 'src/utils/insider'
import { INSIDER_SERVICE } from 'src/utils/constant'

function startTracking(customerContainer) {
  // const enableImpactTracking = convertToBoolean(
  //   APPConfig.getAppConfig().enableImpactTracking
  // )
  const enableClarityTracking = convertToBoolean(
    APPConfig.getAppConfig().enableClarityTracking
  )
  // if (enableImpactTracking) {
  //   trackImpactIdentify(customerContainer)
  // }
  if (enableClarityTracking) {
    if (typeof clarity !== 'undefined') {
      // https://learn.microsoft.com/en-us/clarity/setup-and-installation/cookie-consent#step-2
      // to enable clarity tracking
      clarity('consent')
    }
  }
}

function getConsentCookie() {
  const consentCookieKey =
    APPConfig.getAppConfig().consentCookieKey || 'cmapi_cookie_privacy'
  const consentCookieValue = getCookie(consentCookieKey) || ''
  return consentCookieValue
}

function isConsentAcceptedForTracking() {
  if(typeof bigidcmp !== 'undefined' && typeof bigidcmp?.getConsent === 'function') {
    const consent = bigidcmp.getConsent()
    if (consent) {
      const bigIdConsent = consent?.statistics?.services?.find(service => service.id === INSIDER_SERVICE)
      if (bigIdConsent !== undefined) {
        return bigIdConsent?.value === true
      }
    }
  }
  const consentCookieValue = getConsentCookie()
  return consentCookieValue.includes('1,2')
  // cookie value will be "1,2",
  // when mandatory and functional cookie consent are accepted
}

function checkConsentCookieAndEnableTracking(customerContainer) {
  try {
    const consentCookieValue = getConsentCookie()
    if (consentCookieValue) {
      // if cookie value is empty, keep looping
      // if cookie value is found, check for consent acceptance
      if (isConsentAcceptedForTracking()) {
        // when functional and tracking cookie consent accepted,
        startTracking(customerContainer)

        if (!customerContainer.isGDPRAccepted) {
          trackInsiderUserObject({
            userData: customerContainer.profileResponse,
            eventType: 'user',
          })
        }
      } else {
        // cookie consent rejected
        const enableClarityTracking = convertToBoolean(
          APPConfig.getAppConfig().enableClarityTracking
        )
        if (enableClarityTracking) {
          if (typeof consent !== 'undefined') {
            // https://learn.microsoft.com/en-us/clarity/setup-and-installation/cookie-consent#step-2
            // to disable clarity tracking and delete cookies
            clarity('consent', false)
          }
        }
      }
    } else {
      setTimeout(() => {
        checkConsentCookieAndEnableTracking(customerContainer)
      }, 300)
    }
  } catch (error) {
    console.log('error while checking cookies for consent', error)
  }
}

function initBigIdConsent(options) {
  if (IS_BROWSER) {
    window.addEventListener('bigidcmp:widget_ready', () => {
      setLanguageForConsent()
      setConsentUserId(options)
    })
  }
}

function setLanguageForConsent() {
  const locale = getLocaleCodeFromUrl()?.split?.('_')?.[0] || 'en'
  if (typeof bigidcmp != 'undefined') {
    bigidcmp?.setLanguage?.(locale)
  }
}

function setConsentUserId(options) {
  const { userData } = options || {}
  const userId = userData?.referenceAttribute || userData?.referenceAttribute1
  if (typeof bigidcmp != 'undefined' && userId) {
    bigidcmp?.identify?.(userId)
  }
}

export {
  checkConsentCookieAndEnableTracking,
  getConsentCookie,
  isConsentAcceptedForTracking,
  startTracking,
  initBigIdConsent,
}
